import { render } from "./YoutubePlayer.vue?vue&type=template&id=4e91c67c&scoped=true"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js"

import "./YoutubePlayer.vue?vue&type=style&index=0&id=4e91c67c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e91c67c"]])

export default __exports__